var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "page-outline",
    { attrs: { title: _vm.$t("Webheader.message_format_list") } },
    [
      _c("template", { slot: "pageContent" }, [
        _c(
          "div",
          { staticClass: "listPage overflow-hidden" },
          [
            _c(
              "b-row",
              { staticClass: "justify-content-start px-0 mx-0 no-gutters" },
              [
                _c(
                  "b-button",
                  {
                    staticClass: "btn btnFilter",
                    attrs: { disabled: _vm.activateSpinner },
                    on: {
                      click: function ($event) {
                        return _vm.onRefresh()
                      },
                    },
                  },
                  [
                    _c("i", {
                      staticClass: "fa-light fa-rotate-right fs-14px",
                    }),
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("common.rfrsh")) +
                        "\n        "
                    ),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { attrs: { md: "12" } },
                  [
                    _vm.activateSpinner
                      ? _c("spinner")
                      : _c(
                          "div",
                          [
                            _vm.formatFields.length
                              ? _c("b-table", {
                                  staticClass: "mt-3",
                                  attrs: {
                                    fixed: "",
                                    responsive: "",
                                    items: _vm.formatList,
                                    fields: _vm.formatFields,
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }